<template>
  <div
    v-block-loading:initFetch="pageLoading"
    class="m-details"
  >
    <template v-if="!eventId">
      <Empty text="Sorry, there is no eventId here." />
    </template>

    <template v-else>
      <div class="m-details--prematch">
        <BackBar
          ref="topHeader"
          class="m-detail-top-header"
          :class="{
            fixed: changeText,
          }"
        >
          <h2 class="m-back-title">
            <keep-alive>
              <template v-if="changeText">
                <div class="teams flex animate__animated animate__fadeIn">
                  <div class="m-team m-home-team">
                    {{ event.homeTeam }}
                  </div>
                  <span class="m-vs">vs</span>
                  <div class="m-team m-away-team">
                    {{ event.awayTeam }}
                  </div>
                </div>
              </template>
              <template v-else>
                <span class="details animate__animated animate__fadeIn">Details</span>
              </template>
            </keep-alive>
          </h2>
        </BackBar>

        <template v-if="pageLoading === false">
          <PrematchSummary class="result" :event="event" />

          <!-- video -->
          <div
            v-if="videoInfo"
            v-html="videoInfo"
          />

          <div v-else style="height:6px" />

          <div class="m-tab-container">
            <StatWidgets
              v-if="navList"
              :list="navList"
              :event-id="event.eventId"
              :sport-id="event.sportId"
              :round-type="event.roundType"
              :nav-fixed-offset-top="44"
              styleType="line"
              no-tips
              tabs-position="top"
            />
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { useEventListener } from '@vueuse/core'
import { throttle } from 'lodash-es'
import axios from 'crypto-fetch/axios'
import BackBar from 'wap/components/BackBar'
import Empty from 'wap/components/Empty'
import PrematchSummary from './pagelet/PrematchSummary'
import { getResultWidgetsNavs } from './config/widgetsNavs'

export default {
  name: 'MatchResult',
  components: {
    BackBar,
    PrematchSummary,
    StatWidgets: () => import(/* webpackPrefetch: true, webpackChunkName: 'stat-widgets' */ 'wap/components/StatWidgets'),
    Empty
  },
  props: {
    eventId: {
      type: String,
      default: '',
      required: true
    }
  },
  setup() {
    const changeText = ref(false)
    const topHeader = ref(null)

    useEventListener(
      window,
      'scroll',
      throttle(() => {
        const eleTop = topHeader.value.$el
        const eleprematch = document.querySelector('.result')
        if (eleTop && eleprematch) {
          const top = eleprematch.getBoundingClientRect().top
          const height = eleTop.getBoundingClientRect().height
          const heightPre = eleprematch.getBoundingClientRect().height
          changeText.value = top - height <= -heightPre * 0.58
        }
      }, 300)
    )

    return {
      changeText,
      topHeader
    }
  },
  data() {
    return {
      pageLoading: false,
      event: {},
      navList: null
    }
  },
  computed: {
    videoInfo() {
      // return "<div style='width:100%;height:0px;position:relative;padding-bottom:56.250%;background:#000;'><iframe src='https://www.scorebat.com/embed/v/M2VMeUZLZ1RBUjQremx4LzBLVmlHQT09/?token=MjY4MTFfMTY2NTYzOTQ3NV8yMTJjZmU3YzNmNmEwODBmY2E1MGFmZjA3MzY3NmEyMWYxMTg1ZGY3&utm_source=api&utm_medium=video&utm_campaign=apitm' frameborder='0' width='100%' height='100%' allowfullscreen allow='autoplay; fullscreen' style='width:100%;height:100%;position:absolute;left:0px;top:0px;overflow:hidden;'></iframe></div>"
      const { videoInfo } = this.event
      if (videoInfo && videoInfo.videos && videoInfo.videos.length) {
        return videoInfo.videos[0].directJmp ? null : videoInfo.videos[0].embed
      }
      return null
    }
  },
  created() {
    if (this.eventId) {
      this.initFetch()
    }
  },
  methods: {
    async initFetch() {
      this.pageLoading = true
      try {
        const data = await axios.get(`/facts-center/query/frontend/match?eventId=${this.eventId}`)

        this.event = data
        this.navList = getResultWidgetsNavs(data.sportId)
        this.pageLoading = false
      } catch (error) {
        this.$dialog({
          message: error.message
        }).catch(console.log)
        this.pageLoading = -1
      }
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");
@import url("~base/style/animate.min.css");

.m-details {
  .m-detail-top-header {
    background: url("../../components/Header/images/bg-header.png") no-repeat 0 -46px;
    background-size: 100% 90px;

    &.fixed {
      background: #1c1c1c;
    }
  }

  .m-detail-top-header.fixed ~ .m-tab-container .m-stats-widgets .snap-nav {
    border-radius: 0;
  }

  .m-back-title {
    position: relative;
    height: 100%;
    font-size: 18px;

    .m-vs {
      margin: 0 10px 0 6px;
      color: #999;
      font-size: 10px;
      font-weight: 400;
    }

    .m-team {
      max-width: 40vw;
      font-size: 14px;
      .ellipsis();
    }
  }

  .m-tab-navs {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10/@rem 8/@rem;

    .m-nav-item {
      height: 32/@rem;
      flex: 1;
      border-radius: 1px;
      margin: 0 2/@rem;
      background: #333;
      color: #999;
      font-size: 16/@rem;
      line-height: 32/@rem;
      text-align: center;

      &.active {
        background: #666;
        color: #fff;

        .svg-icon {
          color: #fff;
        }
      }

      .svg-icon {
        margin-right: 4/@rem;
        color: #999;
        font-size: 16/@rem;
      }
    }
  }

  .m-tab-container {
    color: #fff;
  }
}
</style>
<style lang="scss" scoped>
.m-detail-top-header {
  position: sticky;
  z-index: 1001;
  top: 0;
  width: 100%;
  align-items: stretch;
}

[data-mode="light"] .m-details {
  background: #f8f8f8;

  .m-back-bar {
    background: #f8f8f8;
    color: #999;

    ::v-deep .m-back-title {
      color: #000;
    }

    ::v-deep .inline-svg {
      color: #999;
    }
  }

  ::v-deep .m-detail-top-header.fixed ~ .m-tab-container .m-stats-widgets .snap-nav-wrap {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 11%);
  }
}
</style>
